// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PWalletOutlinedSvg from "@fishx/icons-svg/es/asn/PWalletOutlined";
import FishxIcon from '../components/FishxIcon';

var PWalletOutlined = function PWalletOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PWalletOutlinedSvg
  }));
};

PWalletOutlined.displayName = 'PWalletOutlined';
export default React.forwardRef(PWalletOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PWalletOutlined.js
// module id = 3736
// module chunks = 0